/**
 * Image field values may be a single data URL/base64 string or a JSON array of strings.
 */

export function parseImageFieldValue(raw) {
  if (raw == null || raw === '') return [];
  const trimmed = String(raw).trim();
  if (!trimmed) return [];
  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.filter((s) => typeof s === 'string' && s.length > 0);
      }
    } catch {
      /* treat as single value */
    }
  }
  return [trimmed];
}

export function serializeImageFieldValue(images) {
  const filtered = (images || []).filter((s) => typeof s === 'string' && s.length > 0);
  if (filtered.length === 0) return '';
  if (filtered.length === 1) return filtered[0];
  return JSON.stringify(filtered);
}
